module.exports = __webpack_public_path__ + "img/icon-minus.0035f16e.svg";